import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/calendar-day-dialog.css';

const CalendarDayDialog = ({ date, entries, rehearsals, onSelectEntry, onClose }) => {
  // const { t } = useLanguage(); // TODO: Add localization
  
  // Format date for display
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  
  // Get entry type icon
  const getEntryIcon = (entry) => {
    if (entry.icon) {
      return entry.icon;
    }
    
    switch (entry.entry_type) {
      case 'rehearsal_notes':
        return '📝';
      case 'performance':
        return '🎭';
      case 'notice':
        return '📢';
      case 'rehearsal_info':
        return '🎵';
      default:
        return '📅';
    }
  };
  
  // Get entry type display name
  const getEntryTypeDisplay = (type) => {
    switch (type) {
      case 'rehearsal_notes':
        return 'Rehearsal Notes';
      case 'performance':
        return 'Performance';
      case 'notice':
        return 'General Notice';
      case 'rehearsal_info':
        return 'Rehearsal Information';
      default:
        return type;
    }
  };
  
  // Create all items for this day (rehearsals + entries)
  const allItems = [];
  
  // Add rehearsals as items
  rehearsals.forEach(rehearsal => {
    // Check if this rehearsal has associated notes
    const rehearsalNotes = entries.find(entry => 
      entry.entry_type === 'rehearsal_notes'
    );
    
    allItems.push({
      id: `rehearsal-${rehearsal.date}-${rehearsal.time}`,
      entry_type: 'rehearsal_info',
      title: `Rehearsal - ${rehearsal.time}`,
      date: date,
      content: `Scheduled rehearsal at ${rehearsal.time}${rehearsal.location ? ` at ${rehearsal.location}` : ''}`,
      created_at: new Date().toISOString(),
      audio_clips: [],
      hasNotes: !!rehearsalNotes,
      associatedNotes: rehearsalNotes,
      isRehearsalInfo: true
    });
  });
  
  // Add regular calendar entries
  entries.forEach(entry => {
    allItems.push(entry);
  });
  
  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="calendar-day-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <div className="day-header">
            <h3 className="day-title">{formatDate(date)}</h3>
            <p className="day-subtitle">{allItems.length} {allItems.length === 1 ? 'item' : 'items'}</p>
          </div>
          
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <div className="dialog-content">
          <div className="day-items-list">
            {allItems.map((item, index) => (
              <div 
                key={item.id || index}
                className={`day-item ${item.isRehearsalInfo ? 'rehearsal-item' : 'entry-item'}`}
                onClick={() => onSelectEntry(item)}
              >
                <div className="item-icon">
                  <span>{getEntryIcon(item)}</span>
                </div>
                
                <div className="item-content">
                  <div className="item-header">
                    <h4 className="item-title">{item.title}</h4>
                    <span className="item-type">{getEntryTypeDisplay(item.entry_type)}</span>
                  </div>
                  
                  {item.content && (
                    <p className="item-preview">
                      {item.content.substring(0, 120)}
                      {item.content.length > 120 ? '...' : ''}
                    </p>
                  )}
                  
                  <div className="item-badges">
                    {item.hasNotes && (
                      <div className="item-badge">
                        <span>📝 Has notes</span>
                      </div>
                    )}
                    
                    {item.audio_clips && item.audio_clips.length > 0 && (
                      <div className="item-badge">
                        <span>🎵 {item.audio_clips.length} clip{item.audio_clips.length > 1 ? 's' : ''}</span>
                      </div>
                    )}
                  </div>
                </div>
                
                <div className="item-arrow">
                  ›
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarDayDialog;